import React from 'react';
import PropTypes from 'prop-types';
import ManagePaymentBL from '../ManagePaymentBL';
import DateUtils from '../../../utils/DateUtils';
import config from '../../../config';
import moment from 'moment';
import NumberUtils from '../../../utils/NumberUtils';

class ActiveStandingOrderRepeatingFields extends React.Component {
  componentWillMount() {
    /* Changes as per BOW-2778 by Shubham Jain
		removed the calculation for the frequency and end condition from render and put it in component will mount
		repeat data will be as per the payment type normal so or complex so
		*/
    const repeatData = ManagePaymentBL.getRepeatData(this.props.activeData);
    this.setState({ repeatData });
  }

  render() {
    const endCondition = this.props.activeData.scheduleData['end_condition'];
    let stopWhen = 'When I cancel';
    let endKey = null;
    let endValue = null;
    if (endCondition) {
      if (endCondition.hasOwnProperty('when')) {
        stopWhen = 'Pick a date';
        endKey = 'End date';
        let endDate = DateUtils.getMomentFromDateString(endCondition.when);
        endDate = moment(endDate).format(config.dateFormatTimeline);
        endValue = endDate;
      } else {
        stopWhen = 'After a number of times';
        endKey = 'How many times?';
        endValue = endCondition['number_of_payments'];
      }
    }
    const formData = `${this.props.activeData.fromAccountName}-${this.props.activeData.fromAccountNumber}`;
    return (
      <dl className="c-definitions">
        <dt className="c-definitions__key">From</dt>
        <dd className="c-definitions__value">{formData}</dd>
        <dt className="c-definitions__key">To</dt>
        <dd className="c-definitions__value">
          {this.props.activeData.toAccountName}
        </dd>
        <dt className="c-definitions__key">Their sort code</dt>
        <dd className="c-definitions__value">
          {NumberUtils.formatSortCode(this.props.activeData.sortCode)}
        </dd>
        <dt className="c-definitions__key">Their account number</dt>
        <dd className="c-definitions__value">
          {this.props.activeData.accountNumber}
        </dd>
        <dt className="c-definitions__key">Reference</dt>
        <dd className="c-definitions__value">
          {this.props.activeData.reference}
        </dd>
        <dt className="c-definitions__key">Type</dt>
        <dd className="c-definitions__value">{this.props.activeData.type}</dd>
        <dt className="c-definitions__key">Amount</dt>
        <dd className="c-definitions__value">
          <strong>
            &pound;
            {NumberUtils.decimalFormat(this.props.activeData.amount, 3, false)}
          </strong>
        </dd>
        <dt className="c-definitions__key">Next due</dt>
        <dd className="c-definitions__value">
          {this.state.repeatData.nextDue}
        </dd>
        <dt className="c-definitions__key">Frequency</dt>
        <dd className="c-definitions__value">
          {this.state.repeatData.frequency}
        </dd>
        <dt className="c-definitions__key">Stop it when?</dt>
        <dd className="c-definitions__value">{stopWhen}</dd>
        {endCondition ? <dt className="c-definitions__key">{endKey}</dt> : null}
        {endCondition ? (
          <dd className="c-definitions__value">{endValue}</dd>
        ) : null}
      </dl>
    );
  }
}

ActiveStandingOrderRepeatingFields.propTypes = {
  activeData: PropTypes.object,
};
export default ActiveStandingOrderRepeatingFields;
